import { render, staticRenderFns } from "./UserGuide.vue?vue&type=template&id=3b8bd85a&scoped=true&"
import script from "./UserGuide.vue?vue&type=script&lang=js&"
export * from "./UserGuide.vue?vue&type=script&lang=js&"
import style0 from "./UserGuide.vue?vue&type=style&index=0&id=3b8bd85a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8bd85a",
  null
  
)

export default component.exports